import chatService from '../services/chatService'

const HEARTBEAT_INTERVAL_MS = 60_000

export function startChatPresenceHeartbeat(): () => void {
  let stopped = false

  const beat = () => {
    if (stopped) return
    chatService.sendPresenceHeartbeat().catch(() => undefined)
  }

  beat()
  const timer = window.setInterval(beat, HEARTBEAT_INTERVAL_MS)

  const handleVisibility = () => {
    if (document.visibilityState === 'visible') {
      beat()
    }
  }

  document.addEventListener('visibilitychange', handleVisibility)

  return () => {
    stopped = true
    window.clearInterval(timer)
    document.removeEventListener('visibilitychange', handleVisibility)
  }
}

export function formatCounterpartPresence(
  online?: boolean | null,
  lastSeenAt?: string | null,
  formatTimestamp?: (value: string | null | undefined) => string,
): string {
  if (online) {
    return 'Online'
  }
  if (lastSeenAt && formatTimestamp) {
    return `Last seen ${formatTimestamp(lastSeenAt)}`
  }
  if (lastSeenAt) {
    return 'Offline'
  }
  return 'Offline'
}
